import type {TMillions} from '@kapitalist/contract/types/millions'
import type {TMajorActionPaySomethingData} from '~/game/types'
import {DataBackedModel} from '~/models/base'
import type {TMajorActionUserFacingDescriptionData} from '~/models/game/MajorAction'
import type PortfolioNeighborhood from '~/models/game/PortfolioNeighborhood'

export default abstract class MajorActionRentBase<
  D extends TMajorActionPaySomethingData = TMajorActionPaySomethingData,
>
  extends DataBackedModel<D>
  implements Pick<D, 'type'>
{
  // public id: string
  public type: D['type']

  // which neighborhood was used to initiate the rent
  public abstract portfolioNeighborhood: PortfolioNeighborhood

  // what this rent charges, as the backend recorded it
  public abstract millionsOwed: TMillions

  constructor(
    data: D
    // , portfolio: Portfolio
    // , context: TMajorActionConstructorContext
  ) {
    super(data)
    // this.id = data.id
    this.type = data.type
  }

  public abstract userFacingDescription(
    data: TMajorActionUserFacingDescriptionData
  ): string
}
